module.exports = vendor.React;